<template>
  <main class="registrationActive">
    <md-card>
      <md-card-header>
        <div class="md-title">取得履歴</div>
      </md-card-header>
      <div>
        <!--
        <md-tabs @md-changed="onTabChanged" md-alignment="fixed">
          <md-tab id="registry" md-icon="playlist_add_check" md-label="取得済みリスト">
          </md-tab>
          <md-tab id="registration" md-icon="playlist_play" md-label="事件処理中リスト">
          </md-tab>
        </md-tabs>
        -->
        <loading-spinner v-if="loadingSpinner"></loading-spinner>
        <div v-else-if="isRegistry">
          <!-- 検索条件：取得済みリスト -->
          <div class="md-layout">
            <div class="md-layout-item">
              <md-card-content>
                <flash-message class="md-layout-item md-size-100" v-if="registryData.errors.length"
                               :errors="registryData.errors"></flash-message>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <md-field>
                      <label>種類</label>
                      <md-select id="typeSelected" v-model="formRegistry.pdfType" :disabled="sending">
                        <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                        <md-option v-for="(pdfType,index) in pdfTypes" :key="'registry-pdf-type-' + index"
                                   :value="pdfType.code">
                          {{ pdfType.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <md-field>
                      <label>種別</label>
                      <md-select v-model="formRegistry.numberType" :disabled="sending">
                        <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                        <md-option v-for="(value, index) in numberTypes" :value="value.code"
                                   :key="'registry-number-' + index">
                          {{ value.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-30 md-small-size-100">
                    <md-field>
                      <label>所在</label>
                      <md-input :disabled="sending" v-model="formRegistry.address"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-30 md-small-size-100">
                    <md-field>
                      <label>地番／家屋番号</label>
                      <md-input :disabled="sending" v-model="formRegistry.number"></md-input>
                      <span class="md-helper-text">※親番から前方一致での検索となります</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-25 md-small-size-100">
                    <md-field>
                      <label>部門</label>
                      <md-select :disabled="sending" id="typeSelected" v-model="formRegistry.groupId">
                        <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                        <md-option :key="'registry-group-' + index" :value="group.group_id"
                                   v-for="(group, index) in groups">
                          {{ optionLabel(group) }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-25 md-small-size-100" v-if="loadingRegistryAccounts">
                    <md-field>
                      <label>取得者</label>
                      <loading-spinner-overlay></loading-spinner-overlay>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-25 md-small-size-100" v-else>
                    <md-autocomplete :disabled="sending || loadingRegistryAccounts"
                                     :md-options="formRegistry.accounts"
                                     @md-changed="getRegistryAccounts"
                                     @md-opened="getRegistryAccounts"
                                     v-model="formRegistry.accountId">
                      <label>取得者</label>

                      <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                        <md-highlight-text :md-term="term">{{ item }}</md-highlight-text>
                      </template>

                      <template slot="md-autocomplete-empty" slot-scope="{ term }">
                        {{ noDataMessage }}
                      </template>
                    </md-autocomplete>
                  </div>
                </div>
                <div class="md-layout md-size-60 md-gutter md-alignment-center-left">
                  <label class="md-layout md-layout-item md-size-10 md-small-size-100">
                    期間
                  </label>
                  <div class="md-layout md-layout-item md-size-40 md-alignment-center-left">
                    <md-field class="md-layout-item md-size-45 md-small-size-100">
                      <date-picker v-model="formRegistry.startDate"></date-picker>
                    </md-field>
                    <label class="md-alignment-center-center md-layout md-layout-item md-size-10">〜</label>
                    <md-field class="md-layout-item md-size-45 md-small-size-100">
                      <date-picker v-model="formRegistry.endDate"></date-picker>
                    </md-field>
                  </div>
                  <md-button type="submit" class="md-primary md-raised md-layout-item md-size-15 md-small-size-100"
                             @click="onRegistryPageChanged()" :disabled="sending">
                    <md-icon>search</md-icon>
                    表示する
                  </md-button>
                  <md-button type="button" class="md-primary md-raised md-layout-item md-size-20 md-small-size-100"
                             @click="onBatchDownload()" :disabled="selectedPdfs.length === 0 || sending">
                    <md-icon>file_download</md-icon>
                    一括ダウンロード
                  </md-button>
                </div>
                <div class="md-layout md-size-60 md-gutter md-alignment-center-left">
                  <div class="md-layout md-layout-item md-size-65 md-small-hide">&nbsp;</div>
                  <div class="md-layout md-layout-item md-size-35 md-small-size-100">
                    <span class="md-helper-text">※ダウンロードする登記情報にチェックをしてください。</span>
                    <span class="md-helper-text">※一括でダウンロードできる件数は{{ downloadPdfLimit }}件までです。</span>
                  </div>
                </div>
              </md-card-content>
            </div>
          </div>
          <!-- 一覧：取得済みリスト -->
          <div v-if="listRegistries || registryData.noData">
            <md-card-content>
              <md-table>
                <md-table-toolbar v-if="!pagination.total">
                  <h1 class="md-title">一覧</h1>
                </md-table-toolbar>
                <md-table-toolbar v-else>
                  <div class="md-toolbar-section-start">
                    <label>選択件数＜{{ selectedPdfs.length }}件＞</label>
                  </div>
                  <div class="md-toolbar-section-end">
                    <label>表示件数＜{{ pagination.from }}-{{ pagination.to }}件/{{ pagination.total }}件＞</label>
                  </div>
                </md-table-toolbar>
                <md-table-row>
                  <md-table-head><span><md-checkbox v-model="selectedAllPdfs" @change="onCheckAllClick()"></md-checkbox></span>
                  </md-table-head>
                  <md-table-head><span>取得⽇時</span></md-table-head>
                  <md-table-head><span>種類</span></md-table-head>
                  <md-table-head><span>種別</span></md-table-head>
                  <md-table-head><span>所在、地番／家屋番号</span></md-table-head>
                  <md-table-head><span>取得者(ユーザー名)</span></md-table-head>
                  <md-table-head></md-table-head>
                </md-table-row>
                <md-table-row v-if="loadingRegistry">
                  <md-table-cell class="content-style" colspan="8">
                    <loading-spinner v-if="loadingRegistry"></loading-spinner>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-else-if="registryData.noData === true">
                  <md-table-cell class="content-style" colspan="8"><span>{{ noDataMessage }}</span></md-table-cell>
                </md-table-row>
                <md-table-row :key="'registry-' + index" v-else v-for="(registry, index) in listRegistries">
                  <md-table-cell class="md-checkbox-cell">
                    <md-checkbox v-model="selectedPdfs" :value="registry.id"
                                 @change="onSelectedChanged()"></md-checkbox>
                  </md-table-cell>
                  <md-table-cell>{{ registry.requested_at }}</md-table-cell>
                  <md-table-cell>{{ getPdfTypeValue(registry.pdf_type) }}</md-table-cell>
                  <md-table-cell>{{ getNumberTypeValue(registry.number_type) }}</md-table-cell>
                  <md-table-cell>{{ getLabel(registry.label) }}</md-table-cell>
                  <md-table-cell>{{ registry.account_name }}</md-table-cell>
                  <md-table-cell>
                    <div class="flexbox">
                      <div>
                        <md-button v-if="registry.pre_signed_url" @click.prevent="downloadPdf(registry)"
                                   class="md-raised"
                                   target="_blank">
                          <md-icon class="material-icons">
                            picture_as_pdf
                          </md-icon>
                        </md-button>
                      </div>
                      <div>
                        <router-link
                            :to="{name: 'MapInitial', params:{latitude: registry.latitude, longitude: registry.longitude}}">
                          <md-button class="md-raised">
                            <md-icon>location_searching</md-icon>
                            <span>地図</span>
                          </md-button>
                        </router-link>
                      </div>
                    </div>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <pagination :current-page="registryData.pagination.current_page"
                          :per-page="registryData.pagination.per_page"
                          :total="registryData.pagination.total"
                          @pagechanged="onRegistryPageChanged"
                          v-if="!loadingRegistry && registryData.noData === false && listRegistries.length"
              />
            </md-card-content>
          </div>
        </div>
        <div v-else>
          <!-- 検索条件：事件処理中リスト -->
          <div class="md-layout">
            <div class="md-layout-item">
              <md-card-content>
                <flash-message class="md-layout-item md-size-60" v-if="registrationData.errors.length"
                               :errors="registrationData.errors"></flash-message>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-30 d-small-size-100">
                    <md-field>
                      <label>種類</label>
                      <md-select id="typeSelected" v-model="formRegistration.pdfType" :disabled="sending">
                        <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                        <md-option v-for="(pdfType, index) in pdfTypes" :key="'pdf-type-' + index"
                                   :value="pdfType.code">
                          {{ pdfType.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-30 md-small-size-100">
                    <md-field>
                      <label>種別</label>
                      <md-select v-model="formRegistration.numberType" :disabled="sending">
                        <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                        <md-option v-for="(numberType, index) in numberTypes" :value="numberType.code"
                                   :key="'number-type-' + index">
                          {{ numberType.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <md-field>
                      <label>所在</label>
                      <md-input :disabled="sending" v-model="formRegistration.address"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <md-field>
                      <label>地番</label>
                      <md-input :disabled="sending" v-model="formRegistration.number"></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-30 md-small-size-100">
                    <md-field>
                      <label>部門</label>
                      <md-select id="typeSelected" v-model="formRegistration.groupId" :disabled="sending">
                        <md-option v-for="(group, index) in groups" :value="group.group_id"
                                   :key="'registration-group-' + index">
                          {{ optionLabel(group) }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div v-if="loadingRegistrationAccounts" class="md-layout-item md-size-50 md-small-size-100">
                    <md-field>
                      <label>取得者</label>
                      <loading-spinner-overlay></loading-spinner-overlay>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-30 md-small-size-100" v-else>
                    <md-autocomplete v-model="formRegistration.accountId"
                                     :disabled="!formRegistration.groupId || sending || loadingRegistrationAccounts"
                                     :md-options="formRegistration.accounts"
                                     @md-changed="getRegistrationAccounts"
                                     @md-opened="getRegistrationAccounts">
                      <label>取得者</label>

                      <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                        <md-highlight-text :md-term="term">{{ item }}</md-highlight-text>
                      </template>

                      <template slot="md-autocomplete-empty" slot-scope="{ term }">
                        {{ noDataMessage }}
                      </template>
                    </md-autocomplete>
                  </div>
                  <div class="md-layout-item md-size-40 md-small-size-100">
                    <md-field>
                      <label>取得結果</label>
                      <md-select :disabled="sending" id="typeSelected" v-model="formRegistration.status">
                        <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                        <md-option :key="'status-' + status.code" :value="status.code"
                                   v-for="(status,index) in statuses">
                          {{ status.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <label class="md-layout md-layout-item md-alignment-center-left md-small-size-100">
                    期間
                  </label>
                  <div class="md-layout md-layout-item md-alignment-center md-size-90 md-small-size-100">
                    <md-field class="md-layout-item md-size-20 md-small-size-100">
                      <date-picker v-model="formRegistration.startDate"></date-picker>
                    </md-field>
                    <label class="md-alignment-center-left">〜</label>
                    <md-field class="md-layout-item md-size-20 md-small-size-100">
                      <date-picker v-model="formRegistration.startDate"></date-picker>
                    </md-field>
                    <div class="md-layout md-layout-item md-alignment-center-left">
                      <md-button type="submit" class="md-primary md-raised" @click="onGetRegistration">
                        <md-icon>search</md-icon>
                        表示する
                      </md-button>
                    </div>
                  </div>
                </div>
              </md-card-content>
            </div>
          </div>
          <!-- 一覧：事件処理中リスト -->
          <div v-if="listRegistrations || registrationData.noData">
            <md-card-content>
              <md-table>
                <md-table-toolbar>
                  <h1 class="md-title">一覧</h1>
                </md-table-toolbar>
                <md-table-row>
                  <md-table-head><span>取得⽇時</span></md-table-head>
                  <md-table-head><span>種類</span></md-table-head>
                  <md-table-head><span>種別</span></md-table-head>
                  <md-table-head><span>所在、地番／家屋番号</span></md-table-head>
                  <md-table-head><span>取得結果</span></md-table-head>
                  <md-table-head><span></span></md-table-head>
                </md-table-row>

                <md-table-row v-if="loadingRegistration">
                  <md-table-cell class="content-style" colspan="6">
                    <loading-spinner v-if="loadingRegistration"></loading-spinner>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-else-if="registrationData.noData === true">
                  <md-table-cell class="content-style" colspan="6"><span>{{ noDataMessage }}</span></md-table-cell>
                </md-table-row>

                <md-table-row :key="'registration-' + index" v-else v-for="(registration, index) in listRegistrations">
                  <md-table-cell><span>{{ registration.requested_at }}</span></md-table-cell>
                  <md-table-cell><span>{{ getPdfTypeValue(registration.pdf_type) }}</span></md-table-cell>
                  <md-table-cell><span>{{ getNumberTypeValue(registration.number_type) }}</span></md-table-cell>
                  <md-table-cell><span>{{ registration.label }}</span></md-table-cell>
                  <md-table-cell><span>{{ registration.result }}</span></md-table-cell>
                  <md-table-cell>
                    <md-button class="md-primary md-raised" v-if="canRetryRegister(registration)"
                               @click="retryRegister(registration)">
                      <md-icon>replay</md-icon>
                      再取得
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <pagination :current-page="registrationData.pagination.current_page"
                          :per-page="registrationData.pagination.per_page"
                          :total="registrationData.pagination.total"
                          @pagechanged="onRegistrationPageChanged"
                          v-if="!loadingRegistration && registrationData.noData === false && listRegistrations.length"
              />
            </md-card-content>
            <form novalidate class="md-layout">
              <md-dialog :md-fullscreen="false" :md-active.sync="showRetryModal">
                <md-dialog-title>登記情報提供サービスのパスワードを入力してください</md-dialog-title>
                <md-dialog-content>
                  <div class="md-layout md-gutter">
                    <flash-message class="md-layout-item md-size-100" v-if="errorMessages && errorMessages.length > 0"
                                   :errors="errorMessages"></flash-message>
                    <div class="md-layout-item md-size-100">
                      <md-field :class="getValidationClass('login_id')">
                        <label>登記情報提供サービスID</label>
                        <md-input v-model="form.login_id" readonly></md-input>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('login_id')">{{
                            getValidationResponseMessage('login_id')
                          }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.login_id.required">{{ errors.login_id.required }}</span>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field :class="getValidationClass('password')">
                        <label>パスワード</label>
                        <md-input type="password" v-model="form.password"></md-input>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('password')">{{
                            getValidationResponseMessage('password')
                          }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.password.required">{{ errors.password.required }}</span>
                      </md-field>
                    </div>
                  </div>
                </md-dialog-content>

                <md-dialog-actions>
                  <md-button class="md-raised" @click="onCancelRetryRegister">
                    <md-icon>close</md-icon>
                    <span>キャンセル</span>
                  </md-button>
                  <md-button class="md-raised md-primary" @click="onConfirmRetryRegister">
                    <md-icon>check</md-icon>
                    <span>取得する</span>
                  </md-button>
                </md-dialog-actions>
                <loading-spinner-overlay v-if="sendingRetry"></loading-spinner-overlay>
              </md-dialog>
            </form>
          </div>
        </div>
      </div>
    </md-card>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
    </md-snackbar>
    <md-snackbar :md-active="true" :md-position="'center'" class="md-snackbar-bg__error"
                 v-if="errorMessages.length">
      <flash-message :errors="errorMessages" :inSnackbar="true"></flash-message>
      <md-button class="md-primary" @click="errorMessages = []">閉じる</md-button>
    </md-snackbar>
    <progress-model
        :md-active.sync="downloading"
        :title="'ダウンロード中'"
        :downloading="downloading"
        :download-progress="downloadProgress"
    ></progress-model>
  </main>
</template>

<script>
import axios                                          from "axios";
import moment                                         from "moment";
import {validationMixin}                              from 'vuelidate'
import {required}                                     from 'vuelidate/lib/validators'
import DatePicker                                     from "../../../components/DatePicker";
import FlashMessage                                   from "../../../components/FlashMessage";
import LoadingSpinner                                 from "../../../components/LoadingSpinner";
import LoadingSpinnerOverlay                          from "../../../components/LoadingSpinnerOverlay";
import Pagination                                     from "../../../components/Pagination";
import ValidationError                                from "../../../components/ValidationError";
import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
import Common                                         from "../../../modules/common";
import Validation                                     from "../../../modules/validation";
import CommonMixin                                    from "../../../mixins/commonMixin";
import DownloadPdfsMixin                              from "../../../mixins/downloadPdfsMixin";
import ProgressModel                                  from "../../../components/ProgressModal";

const WITH_TRASHED = 1;

export default {
  name      : "UserRequestHistories",
  components: {
    ProgressModel,
    DatePicker,
    FlashMessage,
    LoadingSpinnerOverlay,
    LoadingSpinner,
    Pagination,
    ValidationError,
  },
  mixins    : [validationMixin, CommonMixin, DownloadPdfsMixin],
  data      : () => ({
    isRegistry                 : true,
    registryData               : {
      errors    : [],
      noData    : false,
      pagination: {
        total       : null,
        per_page    : Common.limitPageDefault,
        current_page: 1,
      },
    },
    registrationData           : {
      errors    : [],
      noData    : false,
      pagination: {
        total       : null,
        per_page    : Common.limitPageDefault,
        current_page: 1,
      },
    },
    formRegistry               : {
      pdfType    : null,
      numberType : null,
      address    : null,
      number     : null,
      groupId    : null,
      accountId  : null,
      accountList: [],
      accounts   : [],
      startDate  : null,
      endDate    : null,
    },
    formRegistration           : {
      pdfType    : null,
      numberType : null,
      address    : null,
      number     : null,
      groupId    : null,
      accountId  : null,
      status     : null,
      accountList: [],
      accounts   : [],
      startDate  : null,
      endDate    : null,
    },
    selectedAllPdfs            : false,
    pdfTypes                   : Common.pdfTypes,
    numberTypes                : Common.numberTypes,
    groups                     : [],
    statuses                   : Common.historyStatuses,
    listRegistries             : [],
    listRegistrations          : [],
    loadingRegistry            : false,
    loadingRegistration        : false,
    loadingRegistryAccounts    : false,
    loadingRegistrationAccounts: false,
    noDataMessage              : Common.messages.errorGet,
    sendingRetry               : false,
    showRetryModal             : false,
    registrationRetry          : null,
    authAccount                : null,
    form                       : {
      login_id: null,
      password: null,
    },
    errors                     : {
      login_id: {
        required: Validation.errorMessage(Validation.rules.required, 'tServiceID'),
      },
      password: {
        required: Validation.errorMessage(Validation.rules.required, 'password'),
      },
    },
    pagination                 : {
      from : null,
      to   : null,
      total: 0,
    },
    downloadPdfLimit           : Common.downloadPdfLimit,
  }),
  validations() {
    return {
      form: {
        login_id: {
          required,
        },
        password: {
          required,
        },
      },
    };
  },
  mounted: function () {
    this.initDisplay();
  },
  methods: {
    initDisplay() {
      this.loadingSpinner          = true;
      this.sending                 = true;
      this.loadingRegistryAccounts = true;
      axios
          .all([
            apiClient.get(apiList.jon.accounts.auth),
            apiClient.get(apiList.jon.groups.list),
            apiClient.get(apiList.accounts.list, {params: {with_trashed: WITH_TRASHED, limit: 1000}})
          ])
          .then(axios.spread((...responses) => {
            const authResponse        = responses[0];
            const groupListResponse   = responses[1];
            const accountListResponse = responses[2];
            if (this.hasResponseErrors(authResponse) ||
                this.hasResponseErrors(groupListResponse) ||
                this.hasResponseErrors(accountListResponse)) {
              return;
            }
            this.formRegistry.accountList = accountListResponse.data.accounts.map((account) => {
              return account.account_id + ': ' + account.name;
            });
            this.authAccount              = authResponse.data;
            if (groupListResponse.data.data) {
              this.groups = this.parsedGroups(groupListResponse.data.data, 0, null);
            }
            this.onGetRegistries();
          }))
          .catch(error => {
            this.formRegistry.accountList = [];
            this.errorMessages            = [error.message];
          })
          .finally(() => {
            this.sending                 = false;
            this.loadingSpinner          = false;
            this.loadingRegistryAccounts = false;
          });
    },
    onTabChanged(activeTab) {
      this.isRegistry = activeTab === 'registry';
    },
    getRegistryAccounts(searchTerm) {
      if (!searchTerm) {
        this.formRegistry.accounts = this.formRegistry.accountList;
      } else {
        this.formRegistry.accounts = this.formRegistry.accountList.filter((account) => account.includes(searchTerm));
      }
    },
    getRegistrationAccounts(searchTerm) {
      if (!searchTerm) {
        this.formRegistration.accounts = this.formRegistration.accountList;
      } else {
        this.formRegistration.accounts = this.formRegistration.accountList.filter((account) => account.includes(searchTerm));
      }
    },
    onGetRegistries() {
      this.sending         = true;
      this.loadingRegistry = true;
      let accountId        = null;
      if (this.formRegistry.accountId) {
        accountId = this.formRegistry.accountId.split(':')[0];
      }
      const data = {
        page       : this.registryData.pagination.current_page,
        limit      : this.registryData.pagination.per_page,
        pdf_type   : this.formRegistry.pdfType === this.unspecified ? null : this.formRegistry.pdfType,
        number_type: this.formRegistry.numberType === this.unspecified ? null : this.formRegistry.numberType,
        label      : this.formRegistry.address,
        number     : this.formRegistry.number,
        group_id   : this.formRegistry.groupId === this.unspecified ? null : this.formRegistry.groupId,
        account_id : accountId,
      };
      if (this.formRegistry.startDate) {
        data.requested_at_begin = moment(this.formRegistry.startDate).format(Common.momentConst.dateFormatShort);
      }
      if (this.formRegistry.endDate) {
        data.requested_at_end = moment(this.formRegistry.endDate).format(Common.momentConst.dateFormatShort);
      }
      this.listRegistries = [];
      apiClient.get(apiList.user.requestRegistries, {params: data})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.registryData.errors = this.errorMessages;
              this.registryData.noData = true;
              return;
            }
            const result        = response.data;
            this.listRegistries = result.data;
            this.setRegistryMetaPagination(result.meta);
            this.registryData.noData = !(this.listRegistries && this.listRegistries.length > 0);
            this.registryData.errors = [];
          })
          .catch(error => {
            this.registryData.errors = [error.message];
            this.registryData.noData = true;
          })
          .finally(() => {
            this.sending         = false;
            this.loadingRegistry = false;
          });
    },
    onGetRegistration() {
      this.sending             = true;
      this.loadingRegistration = true;
      let accountId            = null;
      if (this.formRegistration.accountId) {
        accountId = this.formRegistration.accountId.split(':')[0];
      }
      const data = {
        page              : this.registrationData.pagination.current_page,
        limit             : this.registrationData.pagination.per_page,
        pdf_type          : this.formRegistration.pdfType === this.unspecified ? null : this.formRegistration.pdfType,
        number_type       : this.formRegistration.numberType === this.unspecified ? null : this.formRegistration.numberType,
        address           : this.formRegistration.address,
        number            : this.formRegistration.number,
        group_id          : this.formRegistration.groupId,
        account_id        : accountId,
        status            : this.formRegistration.status,
        requested_at_begin: moment(this.formRegistration.startDate).format(Common.momentConst.dateFormatShort),
        requested_at_end  : moment(this.formRegistration.endDate).format(Common.momentConst.dateFormatShort),
      };
      apiClient.get(apiList.user.requestRegistrations, {params: data})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.registrationData.errors = this.errorMessages;
              return;
            }
            const result           = response.data;
            this.listRegistrations = result.data;
            this.setRegistrationMetaPagination(result.meta);
            this.registrationData.noData = !(this.listRegistrations && this.listRegistrations.length > 0);
            this.registrationData.errors = [];
          })
          .catch(error => {
            this.registrationData.errors = [error.message];
            this.registrationData.noData = true;
          })
          .finally(() => {
            this.sending             = false;
            this.loadingRegistration = false;
          })
    },

    getNumberTypeValue(numberType) {
      let numberTypeName = '';
      this.numberTypes.forEach(numberTypeItem => {
        if (numberType === numberTypeItem.code) {
          numberTypeName = numberTypeItem.name;
        }
      });
      return numberTypeName;
    },
    getPdfTypeValue(pdfType) {
      let pdfName = '';
      this.pdfTypes.forEach(pdfTypeItem => {
        if (pdfType === pdfTypeItem.code) {
          pdfName = pdfTypeItem.name;
        }
      });
      return pdfName;
    },
    /**
     * ラベルから種別を除去したものを返す
     *
     * @param label
     * @returns {*}
     */
    getLabel(label) {
      let removedNumberType = label;
      this.numberTypes.forEach(numberTypeItem => {
        removedNumberType = removedNumberType.replace(numberTypeItem.name + '・', '');
      });
      return removedNumberType;
    },
    canRetryRegister(registration) {
      if (registration.status !== 1) {
        return false;
      }
      return !registration.s3_object_url;
    },
    retryRegister(registration) {
      this.form.login_id     = this.authAccount ? this.authAccount.t_service_id : null;
      this.form.password     = null;
      this.registrationRetry = registration;
      this.showRetryModal    = true;
    },
    onCancelRetryRegister() {
      this.showRetryModal    = false;
      this.registrationRetry = null;
    },
    onConfirmRetryRegister() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.sendingRetry = true;
      apiClient
          .post(apiList.jon.retry_registration, {
            token   : this.registrationRetry.token,
            login_id: this.form.login_id,
            password: this.form.password,
          })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.errorMessages = [Common.messages.registration.retry.error];
              return;
            }
            this.showSnackBar      = true;
            this.successMessage    = Common.messages.registration.retry.success;
            this.showRetryModal    = false;
            this.registrationRetry = null;
            this.onGetRegistration();
          })
          .catch(error => {
            this.errorMessages = [Common.messages.registration.retry.error];
          })
          .finally(() => {
            this.sendingRetry = false;
            this.$v.form.$reset();
          })
    },
    setRegistryMetaPagination(meta) {
      this.registryData.pagination.total        = meta.total;
      this.registryData.pagination.per_page     = meta.per_page;
      this.registryData.pagination.current_page = meta.current_page;
      this.pagination.total                     = meta.total;
      this.pagination.from                      = meta.from;
      this.pagination.to                        = meta.to;
    },
    setRegistrationMetaPagination(meta) {
      this.registrationData.pagination.total        = meta.total;
      this.registrationData.pagination.per_page     = meta.per_page;
      this.registrationData.pagination.current_page = meta.current_page;
      this.pagination.total                         = meta.total;
      this.pagination.from                          = meta.from;
      this.pagination.to                            = meta.to;
    },
    onRegistryPageChanged(page = 1) {
      this.selectedPdfs                         = [];
      this.selectedAllPdfs                      = false;
      this.registryData.pagination.current_page = page;
      this.onGetRegistries();
    },
    onRegistrationPageChanged(page) {
      this.registrationData.pagination.current_page = page;
      this.onGetRegistration();
    },
    getRegistryMaxDate() {
      return this.formRegistry.endDate;
    },
    getRegistryMinDate() {
      return this.formRegistry.startDate;
    },
    getRegistrationMaxDate() {
      return this.formRegistration.endDate;
    },
    getRegistrationMinDate() {
      return this.formRegistration.startDate;
    },
    optionLabel(group) {
      if (group.level === 0) {
        return group.name;
      }
      return new Array(group.level + 1).join('　') + group.name;
    },
    onCheckAllClick() {
      this.selectedPdfs = [];
      if (this.selectedAllPdfs) {
        this.selectedPdfs = this.listRegistries.map(registry => registry.id).filter(Boolean);
      }
    },
    onSelectedChanged() {
      this.selectedAllPdfs = this.selectedPdfs.length > 0 && this.selectedPdfs.length === this.listRegistries.length;
    },
    onBatchDownload() {
      if (this.selectedPdfs.length > Common.downloadPdfLimit) {
        this.errorMessages = [this.limitErrorMessage()];
        return;
      }
      const self = this;
      this.downloadPdfs().then((result => {
        if (result) {
          self.selectedPdfs    = [];
          self.selectedAllPdfs = false;
        }
      }));
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep(.md-tabs.md-theme-default) {
  .md-tabs-navigation {
    background-color: #eee;
    padding-top: 2px;
    padding-bottom: 3px;

    .md-button {
      width: 50%;
      max-width: 50%;
      background-color: #f0f0f0;

      &.md-active {
        background-color: #ffffff;
      }
    }
  }

  .md-tabs-indicator {
    margin-bottom: 3px;
  }
}

.md-table-content {
  .md-table-row {
    ::v-deep(.md-table-head-label) {
      padding-left: 16px;
      padding-right: 16px;
    }

    ::v-deep(.md-table-cell-container) {
      padding: 6px 16px 6px 16px;
    }

    ::v-deep(.md-checkbox-cell) {
      .md-table-cell-container {
        padding-left: 16px;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .md-table-content {
    .md-table-row {
      ::v-deep(.md-table-cell-container) {
        padding: 6px;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .md-table-content {
    .md-table-row {
      .md-table-cell {
        .md-ripple {
          span {
            display: none;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import "src/assets/scss/components.scss";
</style>
